(function () {
  'use strict';

  if (window.JCICollectionList) {
    window.JCICollectionList.initAll();
    return;
  }

  var ROOT_SELECTOR = '[data-jci-collection-list]';
  var YMM_SECTION_CLASS = 'jci-collection-list-page__ymm';
  var YMM_DARK_CLASS = 'jci-collection-list-page__ymm--dark';
  var YMM_LIGHT_CLASS = 'jci-collection-list-page__ymm--light';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function findYmmSection(root) {
    var main = root.closest('#main') || document.getElementById('main');
    if (!main) return null;

    var searchboxes = Array.prototype.slice.call(main.querySelectorAll('.shopify-section--apps #ymm_searchbox'));
    var precedingSearchboxes = searchboxes.filter(function (searchbox) {
      return Boolean(searchbox.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING);
    });

    return precedingSearchboxes.length ? precedingSearchboxes[precedingSearchboxes.length - 1].closest('.shopify-section--apps') : null;
  }

  function enhanceYmm(root) {
    var appSection = findYmmSection(root);
    if (!appSection) return false;

    var label = appSection.querySelector('#ymm_label');
    if (!label) return false;

    appSection.classList.add(YMM_SECTION_CLASS);
    appSection.classList.remove(YMM_DARK_CLASS, YMM_LIGHT_CLASS);
    appSection.classList.add(root.dataset.ymmTheme === 'light' ? YMM_LIGHT_CLASS : YMM_DARK_CLASS);
    appSection.setAttribute('data-jci-ymm-owner', root.dataset.sectionId || '');

    root.jciYmmSection = appSection;

    function syncDropdownLayer() {
      var hasOpenDropdown = Boolean(appSection.querySelector(
        '.ss-main.ss-open-below, .ss-main.ss-open-above, .ss-content.ss-open-below, .ss-content.ss-open-above'
      ));
      appSection.classList.toggle('jci-collection-list-page__ymm--dropdown-open', hasOpenDropdown);
    }

    if (!root.jciYmmDropdownObserver && typeof MutationObserver !== 'undefined') {
      root.jciYmmDropdownObserver = new MutationObserver(syncDropdownLayer);
      root.jciYmmDropdownObserver.observe(appSection, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class']
      });
    }

    syncDropdownLayer();
    return true;
  }

  function observeYmm(root) {
    if (enhanceYmm(root)) return function () {};

    var main = root.closest('#main') || document.getElementById('main');
    if (!main || typeof MutationObserver === 'undefined') return function () {};

    var observer = new MutationObserver(function () {
      if (enhanceYmm(root)) observer.disconnect();
    });

    observer.observe(main, { childList: true, subtree: true });

    return function () {
      observer.disconnect();
    };
  }

  function initChannelSplit(root) {
    if (prefersReducedMotion()) return function () {};

    var lastScrollY = window.scrollY;
    var split = 0;
    var frame = 0;
    var maxSplit = 14;

    function decay() {
      split *= 0.88;
      if (split < 0.05) split = 0;
      root.style.setProperty('--jci-split', split.toFixed(2) + 'px');

      if (split > 0) {
        frame = window.requestAnimationFrame(decay);
      } else {
        frame = 0;
      }
    }

    function handleScroll() {
      var velocity = Math.abs(window.scrollY - lastScrollY);
      lastScrollY = window.scrollY;
      split = Math.min(maxSplit, split + velocity * 0.22);
      if (!frame) frame = window.requestAnimationFrame(decay);
    }

    window.addEventListener('scroll', handleScroll, { passive: true });

    return function () {
      window.removeEventListener('scroll', handleScroll);
      if (frame) window.cancelAnimationFrame(frame);
      root.style.removeProperty('--jci-split');
    };
  }

  function initMagnet(root) {
    if (prefersReducedMotion() || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return function () {};

    var grid = root.querySelector('[data-jci-collection-grid]');
    if (!grid) return function () {};

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-jci-magnet-card]'));
    if (!cards.length) return function () {};

    var range = 230;
    var mouseX = -100000;
    var mouseY = -100000;
    var frame = 0;
    var live = false;
    var states = cards.map(function () {
      return { x: 0, y: 0, rx: 0, ry: 0, targetX: 0, targetY: 0, targetRx: 0, targetRy: 0, near: false };
    });

    function aim() {
      var engaged = false;

      cards.forEach(function (card, index) {
        var box = card.getBoundingClientRect();
        var centerX = box.left + box.width / 2;
        var centerY = box.top + box.height / 2;
        var deltaX = mouseX - centerX;
        var deltaY = mouseY - centerY;
        var distance = Math.hypot(deltaX, deltaY);
        var state = states[index];

        if (distance < range) {
          var force = 1 - distance / range;
          state.targetX = deltaX * 0.1 * force;
          state.targetY = deltaY * 0.1 * force;
          state.targetRy = deltaX / box.width * 13 * force;
          state.targetRx = -deltaY / box.height * 13 * force;
          state.near = true;
          engaged = true;
          card.classList.add('is-near');
        } else {
          state.targetX = 0;
          state.targetY = 0;
          state.targetRx = 0;
          state.targetRy = 0;
          state.near = false;
          card.classList.remove('is-near');
        }
      });

      grid.classList.toggle('is-engaged', engaged);
    }

    function spring() {
      var moving = false;

      cards.forEach(function (card, index) {
        var state = states[index];
        state.x += (state.targetX - state.x) * 0.13;
        state.y += (state.targetY - state.y) * 0.13;
        state.rx += (state.targetRx - state.rx) * 0.13;
        state.ry += (state.targetRy - state.ry) * 0.13;

        if (
          Math.abs(state.targetX - state.x) > 0.05 ||
          Math.abs(state.targetY - state.y) > 0.05 ||
          Math.abs(state.targetRx - state.rx) > 0.05 ||
          Math.abs(state.targetRy - state.ry) > 0.05
        ) {
          moving = true;
        }

        card.style.transform =
          'translate3d(' + state.x.toFixed(2) + 'px,' + state.y.toFixed(2) + 'px,0) ' +
          'rotateX(' + state.rx.toFixed(2) + 'deg) rotateY(' + state.ry.toFixed(2) + 'deg)';
      });

      if (moving) {
        frame = window.requestAnimationFrame(spring);
      } else {
        frame = 0;
      }
    }

    function kick() {
      if (!frame) frame = window.requestAnimationFrame(spring);
    }

    function handlePointerMove(event) {
      if (event.pointerType === 'touch') return;
      mouseX = event.clientX;
      mouseY = event.clientY;
      live = true;
      aim();
      kick();
    }

    function handlePointerLeave() {
      mouseX = -100000;
      mouseY = -100000;
      live = false;
      aim();
      kick();
    }

    function handleScroll() {
      if (!live) return;
      aim();
      kick();
    }

    root.addEventListener('pointermove', handlePointerMove, { passive: true });
    root.addEventListener('pointerleave', handlePointerLeave);
    window.addEventListener('scroll', handleScroll, { passive: true });

    return function () {
      root.removeEventListener('pointermove', handlePointerMove);
      root.removeEventListener('pointerleave', handlePointerLeave);
      window.removeEventListener('scroll', handleScroll);
      if (frame) window.cancelAnimationFrame(frame);
      grid.classList.remove('is-engaged');
      cards.forEach(function (card) {
        card.classList.remove('is-near');
        card.style.removeProperty('transform');
      });
    };
  }

  function initBurst(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-jci-burst-card]'));
    var disposers = [];
    var enablePointerScrub = !prefersReducedMotion() && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    cards.forEach(function (card) {
      var frames = Array.prototype.slice.call(card.querySelectorAll('.jci-collection-card__burst-frame'));
      var indicators = Array.prototype.slice.call(card.querySelectorAll('.jci-collection-card__burst-index i'));
      if (frames.length < 2) return;

      var currentIndex = 0;
      var transitionTimer = 0;
      var revealFrame = 0;
      var touchStartX = 0;
      var touchStartY = 0;
      var suppressLinkUntil = 0;

      function settleTransition() {
        window.clearTimeout(transitionTimer);
        transitionTimer = 0;
        if (revealFrame) window.cancelAnimationFrame(revealFrame);
        revealFrame = 0;

        frames.forEach(function (frame, index) {
          frame.classList.toggle('is-current', index === currentIndex);
          frame.classList.remove('is-entering', 'is-entering-from-left', 'is-entering-from-right', 'is-revealed');
        });
      }

      function setFrame(nextIndex) {
        var wrappedIndex = (nextIndex + frames.length) % frames.length;
        if (wrappedIndex === currentIndex) return;

        var revealDirection = nextIndex > currentIndex ? 'right' : 'left';
        settleTransition();

        indicators[currentIndex].classList.remove('is-current');
        indicators[wrappedIndex].classList.add('is-current');
        currentIndex = wrappedIndex;

        var incomingFrame = frames[wrappedIndex];
        incomingFrame.classList.add('is-entering', 'is-entering-from-' + revealDirection);
        revealFrame = window.requestAnimationFrame(function () {
          revealFrame = 0;
          incomingFrame.classList.add('is-revealed');
          transitionTimer = window.setTimeout(settleTransition, 380);
        });
      }

      function handlePointerEnter(event) {
        if (event.pointerType === 'touch') return;
        card.classList.add('is-active');
      }

      function handlePointerMove(event) {
        if (event.pointerType === 'touch') return;
        var box = card.getBoundingClientRect();
        if (!box.width) return;
        var progress = Math.max(0, Math.min(0.999, (event.clientX - box.left) / box.width));
        setFrame(Math.floor(progress * frames.length));
      }

      function handlePointerLeave() {
        card.classList.remove('is-active');
      }

      function handleTouchStart(event) {
        if (event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }

      function handleTouchEnd(event) {
        if (!event.changedTouches.length) return;
        var deltaX = event.changedTouches[0].clientX - touchStartX;
        var deltaY = event.changedTouches[0].clientY - touchStartY;
        if (Math.abs(deltaX) < 34 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;

        event.preventDefault();
        suppressLinkUntil = Date.now() + 450;
        setFrame(currentIndex + (deltaX < 0 ? 1 : -1));
      }

      function handleCardClick(event) {
        if (Date.now() < suppressLinkUntil) event.preventDefault();
      }

      if (enablePointerScrub) {
        card.addEventListener('pointerenter', handlePointerEnter);
        card.addEventListener('pointermove', handlePointerMove, { passive: true });
        card.addEventListener('pointerleave', handlePointerLeave);
      }

      card.addEventListener('touchstart', handleTouchStart, { passive: true });
      card.addEventListener('touchend', handleTouchEnd, { passive: false });
      card.addEventListener('click', handleCardClick);

      disposers.push(function () {
        if (enablePointerScrub) {
          card.removeEventListener('pointerenter', handlePointerEnter);
          card.removeEventListener('pointermove', handlePointerMove);
          card.removeEventListener('pointerleave', handlePointerLeave);
        }
        card.removeEventListener('touchstart', handleTouchStart);
        card.removeEventListener('touchend', handleTouchEnd);
        card.removeEventListener('click', handleCardClick);
        window.clearTimeout(transitionTimer);
        if (revealFrame) window.cancelAnimationFrame(revealFrame);
        card.classList.remove('is-active');
        frames.forEach(function (frame, index) {
          frame.classList.toggle('is-current', index === 0);
          frame.classList.remove('is-entering', 'is-entering-from-left', 'is-entering-from-right', 'is-revealed');
        });
        indicators.forEach(function (indicator, index) {
          indicator.classList.toggle('is-current', index === 0);
        });
      });
    });

    return function () {
      disposers.forEach(function (dispose) {
        dispose();
      });
    };
  }

  function initDamper(root) {
    if (prefersReducedMotion()) return function () {};

    var grid = root.querySelector('[data-jci-collection-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-jci-damper-card]'));
    if (!grid || !cards.length) return function () {};

    var visibleCards = new Set(cards);
    var observer = null;
    var frame = 0;
    var lastScrollY = window.scrollY;
    var impulse = 0;
    var smoothedVelocity = 0;
    var travel = 16;
    var columns = 1;
    var springs = Array.from({ length: 6 }, function (_, index) {
      return {
        y: 0,
        velocity: 0,
        stiffness: 0.155 - index * 0.017,
        damping: 0.76 + index * 0.014
      };
    });

    if (typeof IntersectionObserver !== 'undefined') {
      visibleCards.clear();
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            visibleCards.add(entry.target);
          } else {
            visibleCards.delete(entry.target);
          }
        });
      }, { rootMargin: '15% 0px' });
      cards.forEach(function (card) {
        observer.observe(card);
      });
    }

    function readColumnCount() {
      var renderedColumns = window.getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean);
      return Math.max(1, renderedColumns.length);
    }

    function measure() {
      var box = cards[0].getBoundingClientRect();
      if (box.height) travel = box.height * 0.038;
      columns = readColumnCount();
    }

    function resetCards() {
      cards.forEach(function (card) {
        card.style.removeProperty('--jci-damper-y');
        card.style.removeProperty('--jci-damper-stretch');
        card.style.removeProperty('--jci-damper-load');
      });
    }

    function animate() {
      smoothedVelocity += (impulse - smoothedVelocity) * 0.3;
      impulse *= 0.72;

      var target = Math.max(-travel, Math.min(travel, -smoothedVelocity * 1.7));
      var moving = Math.abs(impulse) > 0.02 || Math.abs(smoothedVelocity) > 0.02;

      for (var index = 0; index < columns; index += 1) {
        var spring = springs[index] || springs[springs.length - 1];
        spring.velocity += (target - spring.y) * spring.stiffness;
        spring.velocity *= spring.damping;
        spring.y += spring.velocity;
        if (Math.abs(spring.velocity) > 0.015 || Math.abs(spring.y) > 0.04) moving = true;
      }

      cards.forEach(function (card, index) {
        if (!visibleCards.has(card)) return;
        var spring = springs[index % columns] || springs[0];
        card.style.setProperty('--jci-damper-y', spring.y.toFixed(2) + 'px');
        card.style.setProperty('--jci-damper-stretch', Math.min(0.05, Math.abs(spring.velocity) * 0.006).toFixed(4));
        card.style.setProperty('--jci-damper-load', Math.min(1, Math.abs(spring.y) / travel).toFixed(3));
      });

      if (moving) {
        frame = window.requestAnimationFrame(animate);
      } else {
        springs.forEach(function (spring) {
          spring.y = 0;
          spring.velocity = 0;
        });
        smoothedVelocity = 0;
        impulse = 0;
        frame = 0;
        resetCards();
      }
    }

    function handleScroll() {
      var nextScrollY = window.scrollY;
      impulse += nextScrollY - lastScrollY;
      lastScrollY = nextScrollY;
      if (!frame) frame = window.requestAnimationFrame(animate);
    }

    function handleResize() {
      measure();
    }

    measure();
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize, { passive: true });
    root.addEventListener('jci:grid-change', handleResize);
    root.addEventListener('jci:filter-change', handleResize);

    return function () {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
      root.removeEventListener('jci:grid-change', handleResize);
      root.removeEventListener('jci:filter-change', handleResize);
      if (observer) observer.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
      resetCards();
    };
  }

  function initCollectionFilters(root) {
    var filters = root.querySelector('[data-jci-collection-filters]');
    var grid = root.querySelector('[data-jci-collection-grid]');
    if (!filters || !grid) return function () {};

    var buttons = Array.prototype.slice.call(filters.querySelectorAll('[data-jci-collection-filter]'));
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-jci-collection-filter-values], [data-jci-collection-filter-value]'));
    var status = root.querySelector('[data-jci-filter-status]');
    if (!buttons.length || !cards.length) return function () {};

    function applyFilter(button) {
      var filterValue = button.getAttribute('data-jci-collection-filter') || 'all';
      var visibleCount = 0;

      buttons.forEach(function (filterButton) {
        var isActive = filterButton === button;
        filterButton.classList.toggle('is-active', isActive);
        filterButton.setAttribute('aria-pressed', String(isActive));
      });

      cards.forEach(function (card) {
        var cardFilterValues = (
          card.getAttribute('data-jci-collection-filter-values') ||
          card.getAttribute('data-jci-collection-filter-value') ||
          ''
        ).split(/[|\s]+/).filter(Boolean);
        var isVisible = filterValue === 'all' || cardFilterValues.indexOf(filterValue) !== -1;
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (status) {
        status.textContent = visibleCount + (visibleCount === 1 ? ' collection shown' : ' collections shown');
      }

      if (window.matchMedia('(max-width: 749px)').matches) {
        button.scrollIntoView({
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }

      root.dispatchEvent(new CustomEvent('jci:filter-change', {
        detail: { filter: filterValue, visibleCount: visibleCount }
      }));
    }

    function handleClick(event) {
      var button = event.target.closest('[data-jci-collection-filter]');
      if (!button || !filters.contains(button)) return;
      applyFilter(button);
    }

    filters.addEventListener('click', handleClick);

    return function () {
      filters.removeEventListener('click', handleClick);
      cards.forEach(function (card) {
        card.hidden = false;
      });
      buttons.forEach(function (button, index) {
        button.classList.toggle('is-active', index === 0);
        button.setAttribute('aria-pressed', String(index === 0));
      });
      if (status) status.textContent = '';
    };
  }

  function initGridSwitcher(root) {
    var grid = root.querySelector('[data-jci-collection-grid]');
    if (!grid) return function () {};

    var desktopButtons = Array.prototype.slice.call(root.querySelectorAll('[data-jci-grid-desktop]'));
    var mobileButtons = Array.prototype.slice.call(root.querySelectorAll('[data-jci-grid-mobile]'));
    if (!desktopButtons.length || !mobileButtons.length) return function () {};

    var resizeFrame = 0;
    var previousColumns = 0;
    var disposers = [];

    function isOneOf(value, allowed) {
      return allowed.indexOf(String(value)) !== -1;
    }

    var desktopDefault = isOneOf(root.dataset.desktopColumns, ['3', '4']) ? root.dataset.desktopColumns : '4';
    var mobileDefault = isOneOf(root.dataset.mobileColumns, ['1', '2']) ? root.dataset.mobileColumns : '2';
    var desktopColumns = desktopDefault;
    var laptopColumns = desktopDefault;
    var mobileColumns = mobileDefault;

    function getMode() {
      if (window.matchMedia('(max-width: 749px)').matches) return 'mobile';
      if (window.matchMedia('(min-width: 1300px)').matches) return 'desktop';
      return 'laptop';
    }

    function applyGrid() {
      var mode = getMode();
      var columns = mode === 'mobile' ? mobileColumns : mode === 'desktop' ? desktopColumns : laptopColumns;
      var isWideDesktop = mode === 'desktop';

      grid.style.setProperty('--jci-grid-columns', columns);
      grid.setAttribute('data-columns', columns);
      root.setAttribute('data-grid-mode', mode);

      desktopButtons.forEach(function (button) {
        var activeValue = isWideDesktop ? desktopColumns : laptopColumns;
        button.setAttribute('aria-pressed', String(button.getAttribute('data-jci-grid-desktop') === activeValue));
      });

      mobileButtons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.getAttribute('data-jci-grid-mobile') === mobileColumns));
      });

      if (previousColumns && previousColumns !== Number(columns)) {
        root.dispatchEvent(new CustomEvent('jci:grid-change', { detail: { columns: Number(columns), mode: mode } }));
      }
      previousColumns = Number(columns);
    }

    desktopButtons.forEach(function (button) {
      function handleClick() {
        var value = button.getAttribute('data-jci-grid-desktop');
        if (getMode() === 'desktop') desktopColumns = value;
        else laptopColumns = value;
        applyGrid();
      }

      button.addEventListener('click', handleClick);
      disposers.push(function () {
        button.removeEventListener('click', handleClick);
      });
    });

    mobileButtons.forEach(function (button) {
      function handleClick() {
        mobileColumns = button.getAttribute('data-jci-grid-mobile');
        applyGrid();
      }

      button.addEventListener('click', handleClick);
      disposers.push(function () {
        button.removeEventListener('click', handleClick);
      });
    });

    function handleResize() {
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(function () {
        resizeFrame = 0;
        applyGrid();
      });
    }

    window.addEventListener('resize', handleResize, { passive: true });
    applyGrid();

    return function () {
      disposers.forEach(function (dispose) {
        dispose();
      });
      window.removeEventListener('resize', handleResize);
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      grid.style.removeProperty('--jci-grid-columns');
      grid.removeAttribute('data-columns');
      root.removeAttribute('data-grid-mode');
    };
  }

  function cleanup(root) {
    if (!root || !root.jciCleanup) return;
    root.jciCleanup();
    delete root.jciCleanup;
  }

  function init(root) {
    if (!root || root.jciCleanup) return;

    var designInitializers = {
      channel_split: initChannelSplit,
      magnet: initMagnet,
      burst: initBurst,
      damper: initDamper
    };
    var designInitializer = designInitializers[root.dataset.design] || initChannelSplit;
    var cleanups = [observeYmm(root), initCollectionFilters(root), initGridSwitcher(root), designInitializer(root)];

    root.jciCleanup = function () {
      cleanups.forEach(function (dispose) {
        dispose();
      });

      if (root.jciYmmSection) {
        if (root.jciYmmDropdownObserver) {
          root.jciYmmDropdownObserver.disconnect();
          delete root.jciYmmDropdownObserver;
        }
        root.jciYmmSection.classList.remove(YMM_SECTION_CLASS);
        root.jciYmmSection.classList.remove(YMM_DARK_CLASS, YMM_LIGHT_CLASS);
        root.jciYmmSection.classList.remove('jci-collection-list-page__ymm--dropdown-open');
        root.jciYmmSection.removeAttribute('data-jci-ymm-owner');
        delete root.jciYmmSection;
      }
    };
  }

  function initAll(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) init(target);
    target.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  window.JCICollectionList = {
    init: init,
    initAll: initAll,
    cleanup: cleanup
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    }, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);

    if (event.target.querySelector('#ymm_searchbox')) {
      document.querySelectorAll(ROOT_SELECTOR).forEach(enhanceYmm);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches(ROOT_SELECTOR) ? event.target : event.target.querySelector(ROOT_SELECTOR);
    cleanup(root);

    if (event.target.matches('.shopify-section--apps')) {
      document.querySelectorAll(ROOT_SELECTOR).forEach(function (collectionRoot) {
        if (collectionRoot.jciYmmSection === event.target) delete collectionRoot.jciYmmSection;
      });
    }
  });
})();
